module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNi8xNS8xNGnF/oAAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAAAkklEQVQ4jd2TyxHAIAhEScambMiiLAgKsKDNyUxC8Jdwyl50cfApDBszg5wVY7z53Rtg6T+QQPSs4ReJiA1pHa6q+VhmBgDUteqt13EACDa6rZzzuS+lEBFRSqmbswzRl16hUxDdl5EfxU3ItXEiYvpaIp3XA70q10yJPkFqP/RPpyGrPZmdrRPiOfUmxGPaezoAFg+ZZJFN8QAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./laydate/skins/default/icon.png
// module id = 7
// module chunks = 0